export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-filter-af62ec91adeff7c7492bd89bea915c01.svg";